<script>
import { QForm } from 'quasar'

export default {
  // functional: true,
  // render (createElement, { data, children, props }) {
  //   return createElement(QForm, data, children)
  // }
  extends: QForm
}
</script>
